import { render, staticRenderFns } from "./SimpleTr.vue?vue&type=template&id=63cbc974"
import script from "./SimpleTr.vue?vue&type=script&lang=js"
export * from "./SimpleTr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports